import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import menu from "./_data/menu.json"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './i18n'

Vue.use(ElementUI);
//////////////////////////////////////////////////
Vue.use(VueRouter)
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
////////////////////////////////////////////////
Vue.config.productionTip = false
Vue.component('page-header', () => import("@/_uc/page-header.vue"))
Vue.component('page-footer', () => import("@/_uc/page-footer.vue"))
Vue.component('product', () => import("@/_uc/product.vue"))
///////////////////////////
//var menuToRoutes = null
const menuToRoutes = (data, parent = "") => {
  return data.map(({ path, redirect, page, children }) => {
    const url = `${parent}${path}`
    const route = {
      path,
      component: () => import(`.${page ? page : url}.vue`)
    }
    if (redirect) {
      route.redirect = redirect
    }
    if (children) {
      route.children = menuToRoutes(children, url + "/")
    }

    return route
  })
}
const routes = menuToRoutes(menu)
//console.error(routes)
const router = new VueRouter({
  mode: "history",
  routes
})
window.router = router
//////////////////////////
new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')

